<template>
  <div class="page-content">
    <div class="container-fluid">
      <Breadcrumb
        :pgTitle="$t('nav.certificates')"
        :refs="refs"
        :pgCurrent="pgCurrent"
        :addNew="false"
      >
      </Breadcrumb>

      <div class="row">
        <Loading v-if="pgLoading"> </Loading>

        <div v-if="!pgLoading" class="col-12">
          <CardMultiCertificates
            :course="row.course"
            :title_ar="row.title_ar"
            :title_en="row.title_en"
            :id="this.$route.params.encryptId"
            :attachments="row.attachments"
            :attachment_key="row.attachment_key"
            :files="row.files"
            :image_base64="row.image_base64"
            :certificate_title_ar="row.certificate_title_ar"
            :certificate_title_en="row.certificate_title_en"
            v-on:multiChange="handleCourseMultiLinkChange"
          >
          </CardMultiCertificates>
        </div>
      </div>

      <Buttons
        v-if="!pgLoading"
        :btnLoading="btnLoading"
        :btnCurrent="btnCurrent"
        v-on:submitClicked="handelSubmit"
        v-on:cancelClicked="handleCancel"
      >
      </Buttons>
    </div>
  </div>
</template>
  
  <script>
import iziToast from "izitoast";

export default {
  name: "EditOrNew",
  components: {
    Breadcrumb: () => import("@/components/Breadcrumb.vue"),
    Loading: () => import("@/components/Loading.vue"),
    CardMultiCertificates: () =>
      import("@/components/CardMultiCertificates.vue"),
    Buttons: () => import("@/components/Buttons.vue"),
  },
  data() {
    return {
      // auth
      auth: {
        role: "",
        access_token: "",
      },

      // row
      row: {
        course: [],
        title_ar: [],
        title_en: [],

        body_ar: "",
        body_en: "",

        image_base64: "",
        image_preview: "",

        intro_link: "",
        course_link: "",

        lecturer_id: "",

        attachments: [],
        attachment_key: 1,
        files: [],
        attachment_base64: [],
        certificate_title_ar: [],
        certificate_title_en: [],

        date: "",
        time: "",
        period: "60",
        price: "0.00",
        status: 1,
        sort: "",
        certificates: [],
      },

      msgCurrent: this.$route.params.id ? "Updated" : "Created",
      btnCurrent: this.$route.params.id ? "Update" : "Create",
      methodType: this.$route.params.id ? "PUT" : "POST",
      pgLoading: this.$route.params.id ? true : false,
      pgCurrent: this.$route.params.id ? "Edit" : "Add New",
      btnLoading: false,

      refs: "offlineCourses",
    };
  },
  mounted() {},
  created() {
    // AccessToken & Role
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("role")) {
      this.auth.role = localStorage.getItem("role");
    }

    if (this.$route.params.id) {
      this.fetchRow();
    }
  },
  methods: {
    // fetch Row
    fetchRow() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/" + this.refs + "/" + this.$route.params.id,
        method: "GET",
        data: {},
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;

          this.row.image_preview = res.data.row.image
            ? res.data.row.image.url
            : "";
          this.row.image_base64 = res.data.row.image
            ? res.data.row.image.url
            : "";

          this.row.title_ar = res.data.row.ar.title;
          this.row.title_en = res.data.row.en.title;

          this.row.body_ar = res.data.row.ar.body;
          this.row.body_en = res.data.row.en.body;

          this.row.intro_link = res.data.row.intro_link;

          this.row.course_link = res.data.row.course_link;
          this.row.sort = res.data.row.sort;

          this.row.lecturer_id = res.data.row.lecturer_id;

          // attachment
          this.row.attachment_key = res.data.row.attachment_key;
          if (res.data.row.attachment) {
            for (let i = 0; i <= this.row.attachment_key; i++) {
              let x = i - 1;
              this.row.files[i] = res.data.row.attachment[x]
                ? res.data.row.attachment[x].course_link
                : "";
              this.row.certificate_title_ar[i] = res.data.row.attachment[x]
                ? res.data.row.attachment[x].title
                : "";
              this.row.certificate_title_en[i] = res.data.row.attachment[x]
                ? res.data.row.attachment[x].title_en
                : "";
            }
          }

          this.row.date = res.data.row.date;
          this.row.time = res.data.row.time;
          this.row.period = res.data.row.period;

          this.row.price = res.data.row.price;
          this.row.status = res.data.row.status;
          this.row.certificates = res.data.row.certificates;
        })
        .catch((err) => {
          // 403 Forbidden
          if (err.response && err.response.status == 401) {
            this.clearLocalStorage();
            this.$router.push({ name: "login" });
          } else if (err.response && err.response.status == 403) {
            this.$router.push({ name: "forbidden" });
          } else {
            this.btnLoading = false;
            iziToast.warning({
              icon: "bx bx-angry",
              title: "",
              message: err.response ? err.response.data.message : "" + err,
            });
          }
        })
        .finally(() => {});
    },

    // handle edit Or New submit
    handelSubmit() {
  
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };

      const config = { headers: { "Content-Type": "multipart/form-data" } };

      let certificates =
        this.row.attachments.length >= 2
          ? this.row.attachments.slice(1)
          : this.row.attachments;
      const options = {
        url:
          this.$route.params.type == "educationalProgram"
            ? window.baseURL + "/diplomats-attendance-certificate"
            : window.baseURL + "/offlineCourses-attendance-certificate",
        method: this.methodType,
        data: {
          id: this.$route.params.encryptId,
          certificates: certificates,
          title_ar: this.row.title_ar.slice(1),
          title_en: this.row.title_en.slice(1),
        },
      };
      // console.log(options);
      this.axios(options, config)
        .then(() => {
          this.btnLoading = false;
          iziToast.success({
            icon: "bx bx-wink-smile",
            title: "",
            message:
              this.btnCurrent == "Update"
                ? "تم التعديل بنجاح"
                : "تم الإضافة بنجاح",
          });

          // this.$router.push({ name: this.refs });
        })
        .catch((err) => {
          // 403 Forbidden
          if (err.response && err.response.status == 401) {
            this.clearLocalStorage();
            this.$router.push({ name: "login" });
          } else if (err.response && err.response.status == 403) {
            this.$router.push({ name: "forbidden" });
          } else {
            this.btnLoading = false;
            iziToast.warning({
              icon: "bx bx-angry",
              title: "",
              message: err.response ? err.response.data.message : "" + err,
            });
          }
        })
        .finally(() => {});
    },
    // clear Local Storage
    clearLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("avatar");
      localStorage.removeItem("username");
      localStorage.removeItem("encrypt_id");
      localStorage.removeItem("role");
    },

    // Cancel
    handleCancel() {
      if (confirm("هل انت متأكد؟")) {
        this.$router.push({ name: this.refs });
      }
    },

    // handel Changes from child components
    handleFormChange(event) {
      this.row.title_ar = event.title_ar;
      this.row.title_en = event.title_en;

      this.row.body_ar = event.body_ar;
      this.row.body_en = event.body_en;
    },

    handleLecturerChange(event) {
      this.row.lecturer_id = event.input;
    },

    handleImageChange(event) {
      this.row.image_base64 = event.image_base64;
    },

    handleIntroLinkChange(event) {
      this.row.intro_link = event.input;
    },
    handleSortChange(event) {
      this.row.sort = event.input;
    },
    // handleCourseLinkChange(event) {
    //     this.row.course_link = event.input;
    // },

    handleCourseMultiLinkChange(event) {
      console.log("emit.." + event.title_ar);
      this.row.title_ar = event.title_ar;
      this.row.title_en = event.title_en;
      this.row.attachments = event.attachments;
      this.row.attachment_key = event.attachment_key;
    },

    handleDateChange(event) {
      this.row.date = event.input;
    },

    handleTimeChange(event) {
      this.row.time = event.input;
    },

    handleSelectedCertificate(event) {
      this.row.certificates = event.input.filter((x) => typeof x === "string");
    },

    handlePeriodChange(event) {
      this.row.period = event.input;
    },

    handlePriceChange(event) {
      this.row.price = event.input;
    },

    handleStatusChange(event) {
      this.row.status = event.status;
    },
  },
};
</script>
  